import { Suspense } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";

import { useAppDispatch } from "@/store";
import { clearToken } from "@/store/slices/auth.slice";
import { routes } from "@/routes";
import { Button } from "@/components/ui/button";

export const Layout = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        dispatch(clearToken());
        navigate(routes.login.path);
    };

    return (
        <div className="min-h-screen flex flex-col">
            <nav className="bg-slate-900 text-white px-6 py-3 flex items-center gap-6">
                <span className="font-bold text-lg mr-4">NextTrack</span>
                {[
                    { to: routes.timeline.path, label: "Timeline" },
                    { to: routes.individuals.path, label: "People" },
                    { to: routes.projects.path, label: "Projects" },
                ].map(({ to, label }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            `text-sm hover:text-slate-300 ${isActive ? "text-white font-semibold" : "text-slate-400"}`
                        }
                    >
                        {label}
                    </NavLink>
                ))}
                <Button
                    variant="ghost"
                    size="sm"
                    className="ml-auto text-slate-400 hover:text-white"
                    onClick={handleLogout}
                >
                    Logout
                </Button>
            </nav>
            <main className="flex-1 p-6">
                <Suspense>
                    <Outlet />
                </Suspense>
            </main>
        </div>
    );
};
